import type { ExportResult } from './types'
import type { ZipFileEntry } from './ZipExporter'

export type DownloadPayload =
  | {
      kind: 'zip'
      filename: string
      entries: ZipFileEntry[]
    }
  | {
      kind: 'blob'
      filename: string
      blob: Blob
    }
  | {
      kind: 'text'
      filename: string
      content: string
    }
  | {
      kind: 'none'
    }

/**
 * Convert an export result into a concrete download payload.
 */
export async function prepareDownloadPayload(
  result: ExportResult,
  loadRuntimeContent: () => Promise<string>
): Promise<DownloadPayload> {
  if (result.externalJsFilename) {
    const runtimeContent = result.externalJsContent || await loadRuntimeContent()
    const entries: ZipFileEntry[] = [
      { name: result.filename, content: result.content || '' },
      { name: result.externalJsFilename, content: runtimeContent },
    ]

    if (result.typesContent) {
      entries.push({
        name: result.filename.replace('.tsx', '.d.ts'),
        content: result.typesContent,
      })
    }

    return {
      kind: 'zip',
      filename: result.filename,
      entries,
    }
  }

  if (result.blob) {
    return {
      kind: 'blob',
      filename: result.filename,
      blob: result.blob,
    }
  }

  if (result.content) {
    return {
      kind: 'text',
      filename: result.filename,
      content: result.content,
    }
  }

  return { kind: 'none' }
}
